import { createFileRoute } from '@tanstack/react-router';
import { DashboardPage } from '@/features/operator/dashboard-page';

export const Route = createFileRoute('/operator/')({
    staticData: { crumbs: [{ label: 'shell.operatorConsole' }] },
    component: DashboardPage,
});
